import {
  type ChatGroupMemberParams,
  type ChatGroupMember,
  type ChatGroup,
  type ChatGroupParams,
  type ChatGroupReadState,
  type ChatGroupReadStatePartial,
  ChatGroupMemberRemoved,
} from './types';

export function genChatGroup(arg: ChatGroupParams): ChatGroup {
  return {
    id: 0,
    category: 0,
    creator_uid: '',
    parent_group_id: '',
    name: '',
    avatar: '',
    status: 0,
    create_at: 0,
    update_at: 0,
    is_encryption: 0,
    ...arg,
  };
}

export function genChatGroups(args: ChatGroupParams[]) {
  return args.map(genChatGroup);
}

export function genSearchMember(param: any): ChatGroupMember {
  return {
    ...param,
    user_id: param.user_id || param.userId || param.receiver_id,
  };
}

export function genChatMember(arg: ChatGroupMemberParams): ChatGroupMember {
  return {
    id: 0,
    category: 0,
    name: '',
    username: '',
    avatar: '',
    remark_name: '',
    role: 0,
    create_at: 0,
    update_at: 0,
    removed: ChatGroupMemberRemoved.Normal,
    ...arg,
  };
}

export function genChatMembers(args: ChatGroupMemberParams[]) {
  return args.map(genChatMember);
}

export function genReadState(arg: ChatGroupReadStatePartial): ChatGroupReadState {
  return {
    id: 0,
    message_id: '',
    reader_ids: '',
    expect_read_list: '',
    create_at: 0,
    expire_at: 0,
    ...arg,
  };
}

export function genReadStates(args: ChatGroupReadStatePartial[]) {
  return args.map(genReadState);
}
